import { DropdownItem, ExternalStyles, Tooltip } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import { GrupoSdcDengueEnum } from 'graphql/types.generated'
import { useAlertasSdc } from 'hooks/sdc/useAlertasSdc'
import { useState } from 'react'
import { MetaPath } from 'util/metaPath'

import { PlanoFormModel } from '../PlanoForm'
import SdcCondutaModal from './SdcCondutaModal'

interface SdcCondutaPlanoButtonProps {
  name: MetaPath<PlanoFormModel>
  style?: ExternalStyles
}

export default function SdcCondutaPlanoButton(props: SdcCondutaPlanoButtonProps) {
  const { name, style: externalStyles } = props

  const [modalOpen, setModalOpen] = useState(false)

  const { setGrupoDengue, hasCondutaAplicada } = useAlertasSdc()

  return (
    <div css={externalStyles}>
      <SdcCondutaModal name={name} modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <Tooltip text={tooltipCondutaRecomentada(hasCondutaAplicada)}>
        <DropdownButton
          text='Aplicar conduta recomendada'
          icon='angleDown'
          skin='default'
          kind='primary'
          disabled={hasCondutaAplicada}
          matchButtonWidth
        >
          <DropdownItem onClick={() => setGrupoDengue(GrupoSdcDengueEnum.A)}>Grupo A</DropdownItem>
          <DropdownItem onClick={() => setGrupoDengue(GrupoSdcDengueEnum.B)}>Grupo B</DropdownItem>
        </DropdownButton>
      </Tooltip>
    </div>
  )
}

const tooltipCondutaRecomentada = (hasCondutaAplicada: boolean): string => {
  if (hasCondutaAplicada) {
    return 'A conduta recomendada já foi aplicada neste atendimento.'
  }
  return null
}
